import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';
import SearchBar from '../../searchbar/SearchBar';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';
import CommunicationsService from '../../../service/CommunicationsService';
import DetailedPreferenceModal from './DetailedPreferenceModal';

class CommunicationPreferencesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [],
      rows: [],
      selectedPreference: null,
    };

    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer Id',
      },
    ];
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  onRowSelect(clickedPreference) {
    const { rows, } = this.state;
    const selectedPreference = rows.find((row) => {
      const { raw, } = row;
      return raw.serviceOfferingId === clickedPreference.serviceOfferingId;
    });
    this.setState({
      selectedPreference: selectedPreference.raw,
    });
  }

  onClick(event) {
    this.reset();
    const { combo, search, } = event;
    const { requestedState = {}, } = this.props;
    const { customerId = '', } = requestedState;
    const rows = [];
    const headers = [
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: '',
        display: 'Click here',
      },
      {
        value: 'serviceOfferingId',
        display: 'Service Offering',
      },
    ];

    const criteria = {};
    criteria[combo.value] = search.value.length === 0 ? customerId : search.value;

    CommunicationsService.getCommunicationPreferences(criteria)
      .then((response) => {
        const { preferences, } = response.data;
        if (preferences && preferences.notificationChannelPreferences.length > 0) {
          preferences.notificationChannelPreferences.forEach((preference) => {
            rows.push({
              value: [
                preferences.customerId,
                null,
                preference.serviceOfferingId,
              ],
              raw: preference,
            });
          });
        }

        this.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  showPreferenceInformation(preference) {
    const { sendNavigationRequest, } = this.props;
    if (!preference) {
      return null;
    }

    return (
      <div>
        <p>{`Selected Service Offering Id: ${preference.serviceOfferingId}`}</p>
        <hr />
        <DetailedPreferenceModal sendNavigationRequest={sendNavigationRequest} selectedPreference={preference} />
      </div>
    );
  }

  statefulInitialization() {
    const { click, } = this;
    if (click) {
      click();
    }
  }

  reset() {
    this.setState({
      headers: [],
      rows: [],
      selectedPreference: null,
    });
  }

  _setClickEvent(click) {
    this.click = click;
  }

  render() {
    const { requestedState = {}, } = this.props;
    const { customerId = '', } = requestedState;
    const { headers = [], rows = [], selectedPreference, } = this.state;
    const style = {
      maxHeight: '400px',
    };
    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          defaultText={customerId}
          onClick={data => this.onClick(data)}
          clickConsumer={click => this._setClickEvent(click)}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Preferences By Service Offering Id" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onRowSelect={data => this.onRowSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.showPreferenceInformation(selectedPreference)}
        </div>
      </div>
    );
  }
}

CommunicationPreferencesView.defaultProps = {
  requestedState: undefined,
};

CommunicationPreferencesView.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
  sendNavigationRequest: PropTypes.instanceOf(Function).isRequired,
};

export default CommunicationPreferencesView;
